var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNo3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79 79",
    style: {
      enableBackground: "new 0 0 79 79"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9AB8D1;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    transform: "translate(-143 -9)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    className: "st0",
    cx: 182.5,
    cy: 48.5,
    r: 39.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M178.5,45.6h3.5c1.6,0,2.9-0.4,3.7-1.2s1.2-1.9,1.2-3.3c0-1.3-0.4-2.3-1.2-3.1s-1.9-1.1-3.2-1.1 c-1.2,0-2.3,0.3-3.1,1c-0.8,0.7-1.3,1.6-1.3,2.7h-6.5c0-1.7,0.5-3.2,1.4-4.6c0.9-1.4,2.2-2.4,3.9-3.2c1.7-0.8,3.5-1.1,5.5-1.1 c3.5,0,6.2,0.8,8.1,2.5c2,1.7,2.9,3.9,2.9,6.8c0,1.5-0.5,2.9-1.4,4.1s-2.1,2.2-3.6,2.9c1.8,0.7,3.2,1.6,4.1,3 c0.9,1.3,1.4,2.9,1.4,4.7c0,2.9-1.1,5.2-3.2,7c-2.1,1.8-4.9,2.6-8.4,2.6c-3.3,0-5.9-0.9-8-2.6c-2.1-1.7-3.1-4-3.1-6.8h6.5 c0,1.2,0.5,2.2,1.4,3s2.1,1.2,3.4,1.2c1.5,0,2.8-0.4,3.6-1.2c0.9-0.8,1.3-1.9,1.3-3.2c0-3.3-1.8-4.9-5.4-4.9h-3.4V45.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo3);
export default __webpack_public_path__ + "static/media/no3.ab47e6875ebef706d9ca56518945dc8d.svg";
export { ForwardRef as ReactComponent };